/* ⚛ REACT */
import React from "react";

/* 🎨 STYLES */
import { ContainerPagination, RowContainer, PaginationButton } from "./styles";

/**
 * Componente de Paginação
 * @param {Function} changepage Função para alterar a página
 * @param {int} currentpage Página atual
 * @param {int} last_page Ultima página
 * @returns {React.Component}
*/
const Pagination = ({changepage, currentpage, last_page}) => {

    const Callpage = (page) => {
        changepage(page);
    };
    
    const pageNumbers = [];
    // Define a quantidade máxima de botões 
    const maxButtons = 3;

    // Calcula a faixa de páginas a serem exibidas
    let startPage = Math.max(1, currentpage - Math.floor(maxButtons / 2));
    let endPage = Math.min(startPage + maxButtons - 1, last_page);

    if (endPage - startPage < maxButtons - 1) {
        startPage = Math.max(1, endPage - maxButtons + 1);
    }

    // Adiciona o botão da primeira página
    if (startPage > 1) {
        pageNumbers.push(1);
        if (startPage > 2) {
            pageNumbers.push('...');
        }
    }

    for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
    }

    // Adiciona o botão da última página
    if (endPage < last_page) {
        if (endPage < last_page - 1) {
            pageNumbers.push('...');
        }
        pageNumbers.push(last_page);
    }

    return (
        last_page >= 2 ? (
            <ContainerPagination>
                <RowContainer>
                    {pageNumbers.map((pageNumber, index) => (
                        <PaginationButton
                            key={index}
                            disabled={typeof pageNumber === 'number' && pageNumber !== currentpage ? false : true}
                            $unpress={!pageNumber}
                            $press={pageNumber === currentpage}
                            onClick={() => {
                                if (typeof pageNumber === 'number') {
                                    Callpage(pageNumber);
                                }
                            }}
                        >
                            {typeof pageNumber === 'number' ? pageNumber : '...'}
                        </PaginationButton>
                    ))}
                </RowContainer>
            </ContainerPagination>
        ) : null
    );
};

export default Pagination;